import gql from "graphql-tag";
import { ACCOUNT_BANKING_FRAGMENT, LEDGER_FRAGMENT } from "./fragment";

export const LEDGER_INFO = gql`
  query LedgerInfo($linkcyId: String!) {
    ledgerInfo(linkcyId: $linkcyId) {
      ...LegderInfo
    }
  }
  ${LEDGER_FRAGMENT}
`;

export const ALL_LEDGERS = gql`
  query AllLedgers {
    allLedgers {
      ...LegderInfo
    }
  }
  ${LEDGER_FRAGMENT}
`;

export const BANKING_INFO = gql`
  query BankingInfo($paynovateId: Int!) {
    bankingInfo(paynovateId: $paynovateId) {
      ...AccountBankingInfo
    }
  }
  ${ACCOUNT_BANKING_FRAGMENT}
`;

export const ALL_ACCOUNT = gql`
  query AllAccount {
    allAccount {
      ...AccountBankingInfo
    }
  }
  ${ACCOUNT_BANKING_FRAGMENT}
`;
